import React, { useState, useEffect, useRef } from "react";
import "./style.css";
import { ReactComponent as BackArrow } from "../../../../assets/images/TicketImages/backarrow.svg";
import { ReactComponent as EditPen } from "../../../../assets/images/TicketImages/pen-edit-circle.svg";
import { ReactComponent as Tick } from "../../../../assets/images/TicketImages/tick.svg";
import { ReactComponent as Cross } from "../../../../assets/images/TicketImages/cross.svg";
import { ReactComponent as BackBlur } from "../../../../assets/images/TicketImages/backblur.svg";
import { ReactComponent as Next } from "../../../../assets/images/TicketImages/next.svg";
import { ReactComponent as ChatTick } from "../../../../assets/images/TicketImages/chattick.svg";
import { ReactComponent as Tag } from "../../../../assets/images/ChatImages/dotsmenu.svg";
import TicketMessageContainer from "../CreateTicket/TicketMessageContainer";
import TicketPublicMenu from "./TicketPublicMenu";
import TicketChatMenu from "./TicketChatMenu";
import TicketMergePopUp from "./TicketMergePopUp";
import TicketChatSideBar from "./TicketChatSideBar";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getTicketById,
  updateTicketSubject,
} from "../../../../store/features/getTicketById";
import { getTicketMessagesById } from "../../../../store/features/getTicketMessagesById";
import { getAllTickets, buildTicketListParams } from "../../../../store/features/getAllTickets";
import { useNavigate } from "react-router-dom";
import Loader from "../../../../assets/Loader";
import { ROOT_URL } from "../../../../api/ApiConfig";
import { createAppSocket, emitAgentSetup } from '../../../../api/createAppSocket';
import {
  selectIsTicketDetailSidebarOpen,
  closeTicketDetailSidebar,
} from "../../../../store/features/ticketDetailSidebarSlice";
import Input from "../../../common/InputField";
import { updateTicket } from "../../../../store/features/updateTicket";
import { toast } from "react-toastify";
import { getStatusStyle } from "../../../../utils/index";
import TicketDeatilSkeleton from "./TicketDetailSkeleton";
import { useSocket } from "../../../../SocketContext";
import { markNotificationsReadForContext } from "../../../../store/features/notifications";

let socketInstance = null;
const processedMessageIds = new Set();

// Status mapping for tabs
const statusMap = {
  1: "open",
  2: "pending",
  3: "solved",
  4: "spam",
};

const reverseStatusMap = {
  open: 1,
  pending: 2,
  solved: 3,
  spam: 4,
};

const TickeetChatSection = (props) => {
  const { setSelectedState } = props;
  const socket = useSocket();
  const lastMarkedTicketForNotifications = useRef(null);
  const [activeMenu, setActiveMenu] = useState(false);
  const [activeChatMenu, setActiveChatMenu] = useState(false);
  const [activeTicketMerge, setActiveTicketMerge] = useState(false);
  const [isSocketInitialized, setIsSocketInitialized] = useState(false);
  const [currentStatus, setCurrentStatus] = useState("open");
  const eventHandlersAttached = useRef(false);
  const [transcriptMessages, setTranscriptMessages] = useState([]);
  const [ticketTranscriptMessages, setTicketTranscriptMessages] = useState([]);
  const [isEditingSubject, setIsEditingSubject] = useState(false);
  const [subject, setSubject] = useState("");
  const [subjectLoading, setSubjectLoading] = useState(false);
  const [subjectError, setSubjectError] = useState("");
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const ticketId = searchParams.get("ticketId");
  const navigate = useNavigate();

  const ticketState = useSelector((state) => state.getTicketById);
  const messageState = useSelector((state) => state.ticketMessages);
  const userData = useSelector((state) => state.loginToken);
  const {
    messages,
    loading: messagesLoading,
    error: messagesError,
  } = messageState;

  const { data, loading, error } = ticketState || {
    data: { ticket: null, messages: [] },
    loading: false,
    error: null,
  };
  const { ticket } = data || { ticket: null, messages: [] };
  const ticketMatchesUrl =
    Boolean(ticketId) &&
    Boolean(ticket?._id) &&
    String(ticket._id) === String(ticketId);
  const isTicketDetailSidebarOpen = useSelector(
    selectIsTicketDetailSidebarOpen
  );

  const [customerEmail, setCustomerEmail] = useState(
    ticket?.customerEmail || ""
  );
  const [customerName, setCustomerName] = useState(ticket?.customerName || "");

  useEffect(() => {
    const id = ticketId || ticket?._id;
    if (!id) {
      lastMarkedTicketForNotifications.current = null;
      return;
    }
    if (lastMarkedTicketForNotifications.current === id) return;
    lastMarkedTicketForNotifications.current = id;
    dispatch(markNotificationsReadForContext({ ticketId: id }));
  }, [dispatch, ticketId, ticket?._id]);

  useEffect(() => {
    if (ticket?.status) {
      setCurrentStatus(ticket.status);
    }
  }, [ticket?.status]);

  useEffect(() => {
    if (ticket?.subject) {
      setSubject(ticket.subject);
    }
  }, [ticket?.subject]);

  const handleStatusChange = (newStatus) => {
    setCurrentStatus(newStatus);
  };

  useEffect(() => {
    if (socketInstance && ticketId) {
      console.log("Joining room for ticket:", ticketId);
      socketInstance.emit("joinTicket", ticketId);

      // Optional cleanup: leave room on unmount
      return () => {
        console.log("Leaving room for ticket:", ticketId);
        socketInstance.emit("leaveTicket", ticketId);
      };
    }
  }, [socketInstance, ticketId]);

  useEffect(() => {
    const fetchTranscriptMessages = async () => {
      try {
        const response = await fetch(
          `${ROOT_URL}/message/get-message/${ticket?.chatRoom}`
        );
        const res = await response.json();

        if (res.status === 200 && Array.isArray(res.data)) {
          setTranscriptMessages(res.data);
        } else if (res.success && Array.isArray(res.messages)) {
          setTranscriptMessages(res.messages);
        }
      } catch (error) {
        console.error("Error fetching updated messages:", error);
      }
    };
    if (ticket?.chatRoom) {
      fetchTranscriptMessages();
    }
  }, [ticket?.chatRoom]);

  // New effect for ticket transcript messages in sidebar
  useEffect(() => {
    const fetchTicketTranscript = async () => {
      try {
        const response = await fetch(
          `${ROOT_URL}/ticket/ticket-message/${ticketId}`
        );
        const res = await response.json();

        if (res.status === 200 && Array.isArray(res.data)) {
          setTicketTranscriptMessages(res.data);
        } else if (res.success && Array.isArray(res.messages)) {
          setTicketTranscriptMessages(res.messages);
        }
      } catch (error) {
        console.error("Error fetching ticket messages:", error);
      }
    };
    if (ticketId) {
      fetchTicketTranscript();
    }
  }, [ticketId]);

  useEffect(() => {
    if (!userData?.response?.user?._id || isSocketInitialized) return;

    const initSocket = () => {
      if (!socketInstance) {
        console.log("Creating new socket connection");
        socketInstance = createAppSocket();
      }

      emitAgentSetup(socketInstance);

      const handleConnect = () => {
        console.log("Socket Connected in TicketChatSection");
        console.log("Agent ID:", userData.response.user._id);
        setIsSocketInitialized(true);
      };

      socketInstance.on("connected", handleConnect);

      return () => {
        socketInstance.off("connected", handleConnect);
      };
    };

    const cleanup = initSocket();
    return cleanup;
  }, [userData?.response?.user?._id, isSocketInitialized]);

  useEffect(() => {
    if (!socketInstance || !ticketId || eventHandlersAttached.current) return;

    console.log("Attaching ticket message handler");
    eventHandlersAttached.current = true;

    const handleNewMessage = (payload) => {
      const messageId = `${payload.ticketId}-${payload.message}-${payload.sender}`;

      if (processedMessageIds.has(messageId)) {
        return;
      }

      if (payload.ticketId === ticketId) {
        processedMessageIds.add(messageId);

        dispatch({
          type: "getTicketMessagesById/optimisticAdd",
          payload: {
            type: "user",
            message: payload.message,
            sender: payload.sender,
            created_at: new Date().toISOString(),
            file_image: payload.attachments?.[0]?.url,
            _id: Date.now().toString(),
          },
        });

        // Emit socket event for status change (pending -> open) when customer replies
        if (socket && currentStatus === 'pending') {
          const newStatus = 'open';
          socket.emit('ticket-status-changed', {
            ticketId: payload.ticketId,
            oldStatus: currentStatus,
            newStatus,
            businessId: userData?.response?.user?.business_id,
            ticket: {
              ...ticket,
              status: newStatus
            }
          });
        }
      }
      dispatch(getTicketMessagesById(ticketId));
    };

    const handleSentMessage = (payload) => {
      if (payload.agentId == userData?.response?.user?._id) {
        return;
      }
      const msg = payload.message;
      const messageId = `${payload.ticketId}-${msg._id || msg.message}-${msg.sender
        }`;
      if (processedMessageIds.has(messageId)) {
        return;
      }
      processedMessageIds.add(messageId);
      dispatch({
        type: "getTicketMessagesById/optimisticAdd",
        payload: {
          type: msg.type || "agent",
          message: msg.message,
          sender: msg.sender,
          created_at: new Date().toISOString(),
          file_image: msg.attachments?.[0]?.url,
          attachments: msg.attachments,
          isAdmin: msg.isAdmin,
          isPrivate: msg.isPrivate,
          agent: {
            ...msg.agent,
            agent_image: msg.agent?.agent_image || msg.senderImage || null,
          },
          _id: msg._id || Date.now().toString(),
          agentProfileImage: msg.senderImage || null,
        },
      });
    };

    socketInstance.on("ticket:message:new", handleNewMessage);
    socketInstance.on("ticket:message:sent", handleSentMessage);
    socketInstance.on("ticket:update", (payload) => {
      if (payload.subject) {
        setSubject(payload.subject);
      }
    });

    return () => {
      socketInstance.off("ticket:message:new", handleNewMessage);
      socketInstance.off("ticket:message:sent", handleSentMessage);
      socketInstance.off("ticket:update");
      eventHandlersAttached.current = false;
    };
  }, [dispatch, ticketId, isSocketInitialized]);

  useEffect(() => {
    if (ticketId || ticket?._id) {
      dispatch(getTicketMessagesById(ticketId || ticket?._id));
      dispatch(getTicketById(ticketId || ticket?._id));
    }
  }, [dispatch, ticketId]);

  useEffect(() => {
    return () => {
      if (socketInstance) {
        console.log("Disconnecting socket");
        if (eventHandlersAttached.current) {
          socketInstance.removeAllListeners("ticket:message:new");
          eventHandlersAttached.current = false;
        }
      }
    };
  }, []);

  if (loading && !ticketMatchesUrl) {
    return <TicketDeatilSkeleton />;
  }

  const handleGoBack = () => {
    setSelectedState(0);
    const params = new URLSearchParams(searchParams);
    params.delete("ticketId");
    navigate(`/ticketsection?${params.toString()}`);

    const tabParam = params.get("tab");
    const activeTabForList = tabParam ? reverseStatusMap[tabParam] || 0 : 0;
    dispatch(getAllTickets(buildTicketListParams(activeTabForList, params)));
  };

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  const handleCancelEditSubject = () => {
    setIsEditingSubject(false);
    setSubject(ticket?.subject || "");
    setSubjectError("");
  };

  const handleEditSubject = () => {
    setIsEditingSubject(true);
    setSubject(subject || ticket?.subject || "");
    setSubjectError("");
  };

  let subjectToastShown = false;
  const handleSubjectInputChange = (e) => {
    setSubjectError("");
    const value = e.target.value;
    if (value.length <= 64) {
      setSubject(value);
      subjectToastShown = false;
    } else {
      if (!subjectToastShown) {
        toast.error("Subject cannot exceed 64 characters");
        subjectToastShown = true;
      }
    }
  };

  const handleDoneSubject = async () => {
    if (!subject.trim()) {
      toast.error("Subject cannot be empty");
      return;
    }
    if (subject.trim().length > 64) {
      setSubjectError("Subject cannot exceed 64 characters");
      return;
    }
    setSubjectLoading(true);
    setSubjectError("");
    const trimmedSubject = subject.trim();

    try {
      await dispatch(
        updateTicket({
          ticketId: ticket?._id,
          updateData: { subject: trimmedSubject },
        })
      ).unwrap();

      dispatch(updateTicketSubject({ subject: trimmedSubject }));

      setIsEditingSubject(false);
    } catch (err) {
      setSubjectError("Failed to update subject");
    } finally {
      setSubjectLoading(false);
    }
  };
  return (
    <div className="TicketChat-Container">
      <div className="TicketChat-Main-Container">
        <div className="TicketChat-Main-HeaderContainer">
          <div className="TicketChat-Main-UpperSection">
            <p onClick={() => handleGoBack()}>
              <BackArrow />
            </p>
            {/* <div className="TicketChat-upperright">
              <span>1-30</span>
              <span>of</span>
              <span>1,299</span>
              <div className="TicketArrow-Container">
                <BackBlur />
                <Next />
              </div>
            </div> */}
          </div>
          <div className="TicketHeading-Container">
            <p
              className="Ticketguy-heading"
              style={{
                flex: 1,
                minWidth: 0,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                maxWidth: "300px",
              }}
            >
              {customerName
                ? customerName.charAt(0).toUpperCase() + customerName.slice(1)
                : "N/A"}
            </p>
            <p className="TicketKenzi truncate" style={{ maxWidth: "300px" }}>
              {" "}
              {customerEmail && typeof customerEmail === "string"
                ? customerEmail.toLowerCase()
                : customerEmail}
            </p>
            <div
              className="TicketHeading-SecondContainer"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                marginBottom: isEditingSubject ? "11px" : "18px",
                marginTop: isEditingSubject ? "6px" : "12px",
              }}
            >
              <div className="TicketHeadingOpen-Container">
                <span
                  style={{ ...getStatusStyle(currentStatus), height: "27px" }}
                >
                  {currentStatus.charAt(0).toUpperCase() +
                    currentStatus.slice(1)}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  minWidth: 0,
                  flex: 1,
                  marginLeft: "9px",
                }}
              >
                {isEditingSubject ? (
                  <Input
                    placeholder="Subject"
                    value={subject}
                    onChange={handleSubjectInputChange}
                    title=""
                    noLabel={true}
                  />
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: 0,
                    }}
                  >
                    <span
                      style={{
                        marginRight: 5,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Subject:
                    </span>
                    <span
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        flex: 1,
                      }}
                    >
                      {(() => {
                        const text = subject || ticket?.subject || "N/A";
                        const trimmed =
                          text.length > 32 ? text.slice(0, 32) + "..." : text;
                        return (
                          trimmed.charAt(0).toUpperCase() + trimmed.slice(1)
                        );
                      })()}
                    </span>

                    <EditPen
                      style={{ marginLeft: "12px", cursor: "pointer" }}
                      onClick={handleEditSubject}
                    />
                  </div>
                )}
              </div>
              {isEditingSubject && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "8px",
                  }}
                >
                  <button
                    onClick={handleDoneSubject}
                    disabled={subjectLoading}
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      padding: 0,
                      display: "flex",
                    }}
                  >
                    <Tick />
                  </button>
                  <button
                    onClick={handleCancelEditSubject}
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      marginLeft: "8px",
                      padding: 0,
                      display: "flex",
                    }}
                  >
                    <Cross />
                  </button>
                </div>
              )}
              {isEditingSubject && subjectError && (
                <span style={{ color: "red", fontSize: 12, marginLeft: 8 }}>
                  {subjectError}
                </span>
              )}
            </div>
            {/* <div className="ChatTicketLogo-Container">
              <div style={{ position: "relative" }}>
                <p onClick={() => setActiveMenu(!activeMenu)}>
                  <ChatTick />
                </p>
                {activeMenu && <TicketPublicMenu />}
              </div>
              <div style={{ position: "relative" }}>
                <p onClick={() => setActiveChatMenu(!activeChatMenu)}>
                  {" "}
                  <Tag />
                </p>
                {activeChatMenu && <TicketChatMenu />}
              </div>
            </div> */}
          </div>
        </div>

        <div className="TicketMessageInput-Container-MainScreen">
          <TicketMessageContainer
            setActiveTicketMerge={setActiveTicketMerge}
            messages={messages}
            createdAt={ticket?.created_at || ticket?.createdAt}
            ticketStatus={currentStatus}
            socketInstance={socketInstance}
            assignedAgent={ticket?.assignee?.full_name}
            ticket={ticket}
            transcriptMessages={transcriptMessages}
            customerEmail={customerEmail}
            customerName={customerName}
          />
        </div>
      </div>
      {isTicketDetailSidebarOpen && (
        <>
          <TicketChatSideBar
            activeSidebar={isTicketDetailSidebarOpen}
            setActiveSideBar={() => dispatch(closeTicketDetailSidebar())}
            sideBarData={ticket}
            onStatusChange={handleStatusChange}
            lastMessageTime={
              messages.length > 0
                ? messages[messages.length - 1].created_at
                : ticket?.created_at
            }
            socketInstance={socketInstance}
            isSocketInitialized={isSocketInitialized}
            customerEmail={customerEmail}
            setCustomerEmail={setCustomerEmail}
            customerName={customerName}
            setCustomerName={setCustomerName}
            transcriptMessages={ticketTranscriptMessages.length > 0 ? ticketTranscriptMessages : messages}
          />
        </>
      )}
    </div>
  );
};

export default TickeetChatSection;
